<template>

    <v-card flat max-width="900px">
        <v-card-text>
            <title-card title="Default compensation grid">

                <v-data-table
                        :headers="headers"
                        :items="lois"
                        class="elevation-1"
                        hide-default-footer
                >
                    <template v-slot:body="{ items }">
                        <tbody>
                        <tr v-for="item in items" :key="item.id">
                            <td>
                                <v-edit-dialog
                                        :return-value.sync="item.name"
                                > {{ item.name }}
                                    <v-text-field
                                            slot="input"
                                            v-model="item.name"
                                            label="Edit"
                                            single-line
                                            counter
                                    ></v-text-field>
                                </v-edit-dialog>
                            </td>

                            <td>
                                <v-edit-dialog
                                        :return-value.sync="item.min"
                                > {{ item.min }}
                                    <v-text-field
                                            slot="input"
                                            v-model="item.min"
                                            label="Edit"
                                            single-line
                                            counter
                                    ></v-text-field>
                                </v-edit-dialog>
                            </td>

                            <td>
                                <v-edit-dialog
                                        :return-value.sync="item.max"
                                > {{ item.max }}
                                    <v-text-field
                                            slot="input"
                                            v-model="item.max"
                                            label="Edit"
                                            single-line
                                            counter
                                    ></v-text-field>
                                </v-edit-dialog>
                            </td>

                            <td>
                                <v-edit-dialog
                                        :return-value.sync="item.completed"
                                > {{ item.completed }}
                                    <v-text-field
                                            slot="input"
                                            v-model="item.completed"
                                            label="Edit"
                                            single-line
                                            counter
                                    ></v-text-field>
                                </v-edit-dialog>
                            </td>

                            <td>
                                <v-edit-dialog

                                        :return-value.sync="item.quota"
                                > {{ item.quota }}
                                    <v-text-field
                                            slot="input"
                                            v-model="item.quota"
                                            label="Edit"
                                            single-line
                                            counter
                                    ></v-text-field>
                                </v-edit-dialog>
                            </td>

                            <td>
                                <v-edit-dialog
                                        :return-value.sync="item.profile"
                                > {{ item.profile }}
                                    <v-text-field
                                            slot="input"
                                            v-model="item.profile"
                                            label="Edit"
                                            single-line
                                            counter
                                    ></v-text-field>
                                </v-edit-dialog>
                            </td>
                        </tr>
                        </tbody>
                    </template>
                </v-data-table>
            </title-card>
        </v-card-text>
    </v-card>

</template>

<script>

    import TitleCard from "./TitleCard";

    export default {

        components: {
            TitleCard
        },

        data() {
            return {
                tableData: [],
                headers: [
                    {
                        text: 'Name',
                        align: 'left',
                        sortable: false,
                        value: 'name'
                    },
                    {text: 'Min LOI', value: 'min', sortable: false},
                    {text: 'Max <LOI', value: 'max', sortable: false},
                    {text: 'Completed', value: 'completed', sortable: false},
                    {text: 'Quota terminated', value: 'quota', sortable: false},
                    {text: 'Profile terminated', value: 'profile', sortable: false},
                ],
                lois: [
                    {
                        value: false,
                        name: 'Under 5',
                        min: null,
                        max: 5,
                        completed: 50,
                        quota: 20,
                        profile: 20,
                    },
                    {
                        value: false,
                        name: 'Between 5 and <10',
                        min: 5,
                        max: 10,
                        completed: 75,
                        quota: 20,
                        profile: 20,
                    },
                    {
                        value: false,
                        name: 'Between 10 and <15',
                        min: 10,
                        max: 15,
                        completed: 100,
                        quota: 20,
                        profile: 20,
                    },
                    {
                        value: false,
                        name: 'Between 15 and <20',
                        min: 15,
                        max: 20,
                        completed: 150,
                        quota: 20,
                        profile: 20,
                    },
                    {
                        value: false,
                        name: 'Between 20 and <25',
                        min: 20,
                        max: 25,
                        completed: 200,
                        quota: 20,
                        profile: 20,
                    },
                    {
                        value: false,
                        name: 'Between 25 and <30',
                        min: 25,
                        max: 30,
                        completed: 250,
                        quota: 20,
                        profile: 20,
                    },
                    {
                        value: false,
                        name: '30 or over',
                        min: 30,
                        max: null,
                        completed: 300,
                        quota: 20,
                        profile: 20,
                    },
                ]
            }
        },
    }
</script>
